<template lang="pug">
.form-new-preorder
  h2 预定房间

  .ui.icon.positive.message(v-if='current_contract && current_contract.preorderable')
    i.checkmark.icon
    .content
      .header
        | 可预定
      p 当前合同已标记为<b>可预定</b>，并将于 {{days_to_end}} 天后 ({{$formatters.date.to_date(current_contract.date_end)}}) 到期。

  .ui.icon.warning.message(v-if='current_contract && !current_contract.preorderable && days_to_end > 0')
    i.warning.icon
    .content
      .header
        | 当前合同未到期
      p 距离当前合同到期还有 {{days_to_end}} 天 ({{$formatters.date.to_date(current_contract.date_end)}})， 请核对信息确认无误后继续操作。

  .ui.icon.positive.message(v-if='!current_contract')
    i.checkmark.icon
    .content
      .header
        | 空房可预定

  el-form.ui.form(:model='form', :rules='rules', ref='form')
    .three.fields
      el-form-item.ui.field.required(prop='date_start')
        label 开始日期
        datepicker(v-model='form.date_start', type='date', :editable='false', :clearable='false', placeholder='开始日期')
      el-form-item.ui.field.required(prop='date_delivery')
        label 交房日期
        datepicker(v-model='form.date_delivery', type='date', :clearable='false', placeholder='交房日期', :min='form.date_start')
      el-form-item.ui.field.required(prop='duration_months')
        label 合同时长 (月)
        el-input-number(v-model='form.duration_months', :min='1')
      el-form-item.ui.field.required(prop='date_end')
        label 结束日期
        datepicker(v-model='form.date_end', type='date', :clearable='false', placeholder='结束日期', :min='form.date_start')

    .four.fields
      el-form-item.ui.field.required(prop='pay_unit_month')
        label 租金交付单位 (月)
        el-input-number(v-model='form.pay_unit_month', :min='1')
      el-form-item.ui.field.required(prop='pay_unit_month')
        label 租金 / 月
        el-input-number(v-model='form.price_month', type='number', :min='0', :controls='false')
      el-form-item.ui.field.required(prop='management_fee_month')
        label 管理费 / 月
        el-input-number(v-model='form.management_fee_month', :min='0', :controls='false')
      el-form-item.ui.field.required(prop='network_fee_month')
        label 网络费 / 月
        el-input-number(v-model='form.network_fee_month', :min='0', :controls='false')

    h3 预订人信息
    .three.fields
      el-form-item.ui.field.required(prop='customer_name')
        label 姓名
        el-input(v-model='form.customer_name', type='text')
      el-form-item.ui.field.required(prop='customer_phone')
        label 手机
        el-input(v-model='form.customer_phone', type='text')
      el-form-item.ui.field(prop='customer_idcard')
        label 身份证
        el-input(v-model='form.customer_idcard', type='text')

    h3 定金
    .two.fields
      el-form-item.ui.field.required(prop='earnest_money')
        label 定金
        el-input-number(v-model='form.earnest_money', type='number', :min='0', :controls='false')
      el-form-item.field(prop='payment_method')
        label 支付方式
        payment-method-select(v-model='form.payment_method')

    h3 备注
    el-form-item.ui.field(prop='note')
      textarea(v-model='form.note', rows='2')

    .ui.field.actions
      //.ui.button.icon.labeled.teal(@click='print_draft')
        i.icon.print
        | 生成预订单
      .ui.button.themed.icon.labeled(@click='finish')
        i.icon.checkmark
        | 确认签署
      .ui.button(@click='cancel') 取消
</template>

<script>
import { MakeForm } from '../../utils'
import { PaymentMethodSelect, Datepicker } from '../basic'
import FormNewCustomer from './FormNewCustomer.vue'

export default {
  name: 'form-new-preorder',
  components: {
    FormNewCustomer,
    PaymentMethodSelect,
    Datepicker,
  },
  props: ['no'],
  computed: {
    room() {
      return this.$store.getters.room(this.no)
    },
    current_contract() {
      return this.$store.getters.current_contract_of_room(this.no)
    },
    days_to_end() {
      if (this.current_contract) {
        const end_date = this.$moment(this.current_contract.date_end)
        const now = this.$moment().utc().startOf('day')
        return this.$moment.daysBetween(end_date, now)
      }
      return 0
    },
  },
  data() {
    return {
      form: {
        _room: null,
        date_start: '',
        date_end: '',
        date_delivery: '',
        pay_unit_month: 3,
        price_month: 1400,
        duration_months: 3,
        earnest_money: 2000,
        management_fee_month: 50,
        network_fee_month: 0,
        note: '合同押金: 2000 元',
        payment_method: 'cash',
        customer_name: '',
        customer_phone: '',
        customer_idcard: '',
      },
      rules: {
        date_start: [{ required: true, message: '请选择开始日期' }],
        date_end: [{ required: true, message: '请选择结束日期' }],
        date_delivery: [{ required: true, message: '请选择交付日期' }],
        customer_name: { required: true, message: '请输入预定人姓名' },
        customer_phone: { required: true, message: '请输入预定人手机/电话号码' },
      },
    }
  },
  watch: {
    'form.duration_months': function () {
      this.update_date()
    },
    'form.date_start': function () {
      this.update_date()
      this.form.date_delivery = this.$moment(this.form.date_start) // .subtract(15, 'days')
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.form._room = this.room._id
      if (this.current_contract && this.current_contract.date_end)
        this.form.date_start = this.$moment(this.current_contract.date_end).add(1, 'days')
      else
        this.form.date_start = this.$moment().startOf('days')
      this.form.date_end = this.$moment().add(12, 'months').startOf('days')
      this.form.price_month = this.$store.getters.room_price(this.no)

      this.update_date()
    },
    cancel() {
      this.$router.back()
    },
    submit_form: MakeForm({
      type: 'post',
      url: 'preorders/new',
      confirm: '确定预定该房间？',
      payload() {
        return this.form
      },
      $beforeSuccess() {
        this.print_draft()
      },
      $afterSuccess() {
        this.$router.$go.room({ no: this.no, into: false })
        this.$store.dispatch('load_preorders')
      },
    }),
    finish() {
      this.$refs.form.validate((valid) => {
        if (valid)
          this.submit_form()
      })
    },
    update_date() {
      this.form.date_end = this.$moment(this.form.date_start)
        .add(this.form.duration_months, 'month')
        .subtract(1, 'days')
        .toDate()
    },
    print_draft() {
      this.$templater.request('preorder', {
        room: this.room,
        preorder: this.form,
        $methods: this.$store.state.summary.payment_methods,
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// FormNewPreorder.vue?98d8d4fe